const SAFE_PROTOCOLS = new Set(['http:', 'https:']);

export const normalizeAssetUrl = (url: string | undefined | null) => {
  if (!url) {
    return undefined;
  }

  try {
    const parsedUrl = new URL(url);

    if (!SAFE_PROTOCOLS.has(parsedUrl.protocol)) {
      return url;
    }

    parsedUrl.pathname = parsedUrl.pathname
      .split('/')
      .map((segment) => {
        try {
          return encodeURIComponent(decodeURIComponent(segment));
        } catch {
          return encodeURIComponent(segment);
        }
      })
      .join('/');

    return parsedUrl.toString();
  } catch {
    return url;
  }
};
